import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Language } from '../../../common';
import { ToggleFullscreenMode, SetLanguage } from './app.actions';
import { AppState } from './app.state';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppFacade {
  currentLanguage$: Observable<Language> = this.store.select(AppState.getLanguage);
  fullscreenMode$: Observable<boolean> = this.store.select(AppState.getFullscreenMode);

  constructor(private store: Store) {}

  changeLang(lang: Language): void {
    this.store.dispatch(new SetLanguage(lang));
  }

  toggleFullscreenMode(): void {
    this.store.dispatch(new ToggleFullscreenMode());
  }
}
